<template>
  <div class="wrap">
    <div class="tagBox">
      <div class="tag" :class="{'active': tag.isSelected}" v-for="tag in tagList" :key="tag.id" @click="tapTheTag(tag)">{{tag.name}}</div>
    </div>
    <div class="articleList">
      <div class="article" v-for="article in articleList" :key="article.id" @click="turnToArticle(article)">
        <div class="title">· <div class="author" v-if="article.author">{{article.author}} : </div>{{article.title}}</div>
        <div class="infoBox">
          <div class="desc">{{article.digest}}</div>
          <div class="displayTime">{{article.modified}}</div>
          <!-- <div class="displayTime">- 2017年01月01日</div> -->
        </div>
      </div>
    </div>
    <div class="loadmore" @click="loadmoreArticle" v-if="hasNext">加载更多...</div>
  </div>
</template>
<style  lang="less" scoped>
.tagBox {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-bottom: 20px;
  padding-top: 20px;
  .tag {
    min-width: 92px;
    padding: 3px 5px;
    width: 10%;
    border: 1px solid #ddd;
    border-radius: 4px;
    text-align: center;
    margin: 4px 8px;
    color: #888;
    font-size: 0.95em;
    font-weight: 500;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .active {
    color: #006d82;
    border-color: #006d82;
  }
}
.articleList {
  text-align: left;
  padding-bottom: 30px;
  .article {
    cursor: pointer;
    padding-bottom: 16px;
    padding-top: 16px;
    border-bottom: 1px solid #ddd;
    .title {
      font-size: 14px;
      padding-bottom: 10px;
      // font-weight: bold;
      color: #000;
      .author {
        display: inline-block;
        padding-right: 6px;
      }
    }
    .title:hover{
      color: #006d82;
    }
    .infoBox {
      display: flex;
      .desc {
        line-height: 1.5em;
        flex: 1;
        font-size: 13px;
        color: #888;
        padding-right: 8%;
      }
      .displayTime {
        color: #afafaf;
        font-size: 14px;
        align-self: flex-end;
      }
    }
  }
}
.loadmore {
  display: inline-block;
  line-height: 30px;
  padding: 0 30px;
  border: 1px solid #c1c1c1;
  color: #bbb;
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.loadmore:hover {
  border: 1px solid #006d82;
  color: #006d82;
}
.wrap {
  text-align: center;
  padding-bottom: 30px;
}
@media only screen and (max-width: 412px){
 .infoBox{
   flex-direction: column;
 }
}
</style>
<script>
import axios from "axios";
import common from "../common";
export default {
  name: "",
  data() {
    return {
      host: common.network.host,
      categoryList: [],
      start: 0,
      limit: 10,
      categoryId: "",
      tagList: [],
      articleList: [],
      hasNext: true
    };
  },
  mounted: function() {
    let self = this;
    if (this.$route.query.category) {
      let decodeStr = decodeURI(this.$route.query.category);
      axios({
        method: "get",
        url: self.host + "categories",
        data: {}
      })
        .then(res => {
          if (res.status === 200) {
            self.categoryList = res.data;
            self.categoryList.some((ele, index, arr) => {
              if (ele.name.indexOf(decodeStr) != -1) {
                self.categoryId = ele.id;
                return true;
              } else {
                return false;
              }
            });
            if(self.categoryId === ""){
              throw '没有匹配到此分类'
            }
          }
          return axios({
            method: "get",
            url: self.host + self.categoryId + "/tags",
            data: {}
          });
        })
        .then(res => {
          if (res.status === 200 ) {
            res.data.forEach((item, index) => {
              self.tagList.push({
                id: item.id,
                name: item.name,
                isSelected: false
              });
            });
            let data = {
              start: self.start,
              limit: self.limit,
              categoryId: self.categoryId,
              tags: ""
            };
            self.getArticle(data);
          }
        }).catch(e=>{
          alert(e);
        });
    }
  },
  methods: {
    getArticle: function(parms) {
      let self = this;
      axios({
        method: "get",
        url: self.host + self.categoryId + "/articles",
        params: parms
      }).then(res => {
        if (res.status === 200 ) {
          if (self.start == 0) {
            self.articleList = res.data.data;
          } else {
            self.articleList = self.articleList.concat(res.data.data);
          }
          self.hasNext = res.data.hasNext;
          // if (self.hasNext) {
          //   self.start += self.limit;
          // }
        }
      });
    },
    tapTheTag: function(item) {
      let self = this;
      this.start = 0;
      item.isSelected = !item.isSelected;
      let tmpSelArr = [];
      self.tagList.forEach((item, index) => {
        if (item.isSelected) {
          tmpSelArr.push(item.id);
        }
      });
      let data = {
        start: this.start,
        limit: this.limit,
        categoryId: this.categoryId,
        tags: tmpSelArr.join(",")
      };
      this.getArticle(data);
    },
    turnToArticle: function(article) {
      let self = this;
      let parms = {
        type: 'article',
        id: article.id
      }
      axios({
        method: "get",
        url: self.host + article.id + "/view",
        params: parms,
        headers: {
          platform: 'pc'
        }
      }).then(res => {});
      window.open(article.link);
    },
    loadmoreArticle: function() {
      let self = this
      let tmpSelArr = [];
      self.start += self.limit;
      self.tagList.forEach((item, index) => {
        if (item.isSelected) {
          tmpSelArr.push(item.id);
        }
      });
      let data = {
        start: this.start,
        limit: this.limit,
        categoryId: this.categoryId,
        tags: tmpSelArr.join(",")
      };
      this.getArticle(data);
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/pages/articlePage.vue